/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "fda3736edade5296339f68deeae8a82efbcbf120";
